import { useCallback } from "react";
import { useProfilePreference } from "src/common/utils/hooks/useProfilePreference.js";
import { experienceCatalogue } from "./catalogue.js";
import { experiencePreferenceKey } from "./experienceStorage.js";
import type { CompletedExperience } from "./types.js";

export const useExperience = (experienceId: string) => {
	const experience = experienceCatalogue[experienceId];
	const [completion, setCompletion] =
		useProfilePreference<CompletedExperience | null>(
			experiencePreferenceKey(experienceId),
			null,
		);

	const complete = useCallback(() => {
		if (experience) {
			setCompletion({
				completedAt: new Date().toISOString(),
				version: experience.version,
			});
		}
	}, [experience, setCompletion]);

	const reset = useCallback(() => setCompletion(null), [setCompletion]);

	return {
		experience,
		completed:
			experience !== undefined &&
			completion !== null &&
			completion.version >= experience.version,
		completedAt: completion?.completedAt,
		complete,
		reset,
	};
};
